import ExportHistoryShow from './export-history.show';

export default {
  show: ExportHistoryShow,
};
